export function toLocalTimezone(date: Date) {
    return new Date(date);
}
